import { render } from "./ModalMultiTanzaku.vue?vue&type=template&id=e2442524&scoped=true"
import script from "./ModalMultiTanzaku.vue?vue&type=script&lang=js"
export * from "./ModalMultiTanzaku.vue?vue&type=script&lang=js"

import "./ModalMultiTanzaku.vue?vue&type=style&index=0&id=e2442524&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2442524"]])

export default __exports__